'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const IntroductionSection = () => {
  const translate = useTranslate('available_discounts')

  return (
    <section className="available_discounts__introduction-section">
      <h1 className="available_discounts__introduction-title">{translate('title')}</h1>
    </section>
  )
}

export default IntroductionSection
